const EXTENSION_ID = "jjikojjfkjcbjklhldnjdnelfmjjmifg";
// const EXTENSION_ID = "oofhaiekpiepemgdeodaealogdalkdbj";

interface LoginData {
  access_token: string;
  userId: string;
}

export async function syncLoginToExtension(loginData: LoginData) {
  // console.log("🔍 [DEBUG] syncLoginToExtension called with:", {
  //   userId: loginData.userId,
  //   hasToken: !!loginData.access_token,
  // });

  // Check if chrome extension API is available
  const hasChromeAPI = !!(window as any).chrome?.runtime?.sendMessage;
  // console.log("🔍 [DEBUG] Chrome API available:", hasChromeAPI);
  // console.log("🔍 [DEBUG] window.chrome:", (window as any).chrome);

  if (!hasChromeAPI) {
    // console.warn("❌ Chrome extension API not available");
    return { success: false, extensionInstalled: false };
  }

  // console.log("🔍 [DEBUG] Sending message to extension ID:", EXTENSION_ID);

  return new Promise((resolve) => {
    (window as any).chrome.runtime.sendMessage(
      EXTENSION_ID,
      {
        action: "login",
        access_token: loginData.access_token,
        userId: loginData.userId,
      },
      (response: any) => {
        const lastError = (window as any).chrome.runtime.lastError;

        if (lastError) {
          // console.log("❌ Extension error:", lastError.message);
          // console.log("🔍 [DEBUG] This usually means:");
          // console.log("  1. Extension is not installed");
          // console.log("  2. Extension ID is wrong");
          // console.log(
          //   "  3. Extension manifest doesn't allow external connections"
          // );
          resolve({
            success: false,
            extensionInstalled: false,
            error: lastError.message,
          });
        } else {
          // console.log("✅ Login synced to extension successfully:", response);
          resolve({ success: true, response });
        }
      }
    );
  });
}

export async function syncLogoutToExtension() {
  // console.log("🔍 [DEBUG] syncLogoutToExtension called");

  if (!(window as any).chrome?.runtime?.sendMessage) {
    // console.warn("❌ Chrome extension API not available for logout");
    return { success: false };
  }

  // console.log("🔍 [DEBUG] Sending logout message to extension:", EXTENSION_ID);

  return new Promise((resolve) => {
    (window as any).chrome.runtime.sendMessage(
      EXTENSION_ID,
      { action: "logout" },
      (response: any) => {
        const lastError = (window as any).chrome.runtime.lastError;

        if (lastError) {
          // console.log("❌ Extension logout error:", lastError.message);
          resolve({ success: false, error: lastError.message });
        } else {
          // console.log("✅ Logout synced to extension successfully:", response);
          resolve({ success: true, response });
        }
      }
    );
  });
}
